export const convertObjectToString = (params: { [key: string]: string }) => {
  return Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join('&');
};

export const getSortByColumn = (sort: string): string | undefined | null => {
  return sort.substring(0, sort.indexOf(','));
};

export const getOrderSort = (sort: string): string | undefined | null => {
  return sort.substring(sort.indexOf(',') + 1, sort.length) === 'ASC' ? 'ascend' : 'descend';
};

export const matchYoutubeUrl = (url: string) => {
  const p =
    /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  if (url?.match(p)) {
    return url.match(p)?.[1] || false;
  }

  return false;
};

export const getYouTubeVideoIdFromUrl = (url: string) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : undefined;
};

export const checkValidUrl = (url: string) => {
  /* eslint-disable no-useless-escape */
  const regex =
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/y;
  if (regex.test(url)) {
    return true;
  }
  return false;
};

export const urlValidator = (value: string, errMsg: string): Promise<void | string> => {
  if (!value) {
    return Promise.resolve();
  }
  const validUrl = checkValidUrl(value);
  if (!validUrl) {
    return Promise.reject(new Error(errMsg));
  }
  return Promise.resolve();
};
